import * as React from 'react';
import { Typography } from '@mui/material';
import CustomAccordion from '../elements/accordion';
import { Faq } from '../../types/blocks/faq';

interface SectionFrequentlyAskedQuestionsProps {
  element: Faq;
}
export const SectionFrequentlyAskedQuestions: React.FC<SectionFrequentlyAskedQuestionsProps> = ({
  element,
}) => (
  <div className="bg-complementary-light relative">
    <div className="px-4 py-16 md:py-24 lg:py-32 space-y-8 relative z-10">
      <Typography
        variant="h1"
        component="h3"
        className="text-complementary-contrastText text-center"
      >
        {element.title}
      </Typography>
      <div className="max-w-[800px] mx-auto z-10">
        <div className="bg-paper p-8 md:px-10 rounded-2xl">
          {element.questions.length > 0 &&
            element.questions.map((el, index) => (
              <CustomAccordion
                key={el.id}
                title={el.title}
                content={el.description}
                isLast={element.questions.length === index + 1}
              />
            ))}
        </div>
      </div>
    </div>
    <img
      src="/assets/images/homepage/faq-background.svg"
      className="max-w-[1170px] max-h-[90%] absolute left-0 bottom-0"
    />
  </div>
);
